import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
} from '@mui/material';
import VideoLibraryIcon from '@mui/icons-material/VideoLibrary';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

function Navbar() {
  return (
    <AppBar position="static">
      <Toolbar>
        <VideoLibraryIcon sx={{ mr: 2 }} />
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          FakePlex
        </Typography>
        <Box>
          <Button
            color="inherit"
            component={RouterLink}
            to="/"
            startIcon={<VideoLibraryIcon />}
          >
            Library
          </Button>
          <Button
            color="inherit"
            component={RouterLink}
            to="/upload"
            startIcon={<CloudUploadIcon />}
          >
            Upload
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
}

export default Navbar; 